// Copyright 2026. WebPros International GmbH. All rights reserved.

import React from 'react';
import {
    List,
    Translate,
    Icon,
} from '@plesk/ui-library';
import { Link } from 'react-router-dom';
import { EmptyView } from 'common/components/EmptyView/EmptyView';
import { Status } from 'admin/computeResource/common/Status/Status';
import { IComputeResourceResponse } from 'common/api/resources/ComputeResource';
import {
    IResilienceStatusTableComputeResource,
    IResilienceStatusTableProps,
} from 'common/api/resources/DisasterRecovery';

const ResilienceStatusTable: React.FC<IResilienceStatusTableProps> = ({
    compute_resources,
}) => {
    const columns = [
        {
            key: 'colName',
            title: <Translate content="computeResource.list.name" />,
            render: (row: IComputeResourceResponse) => (
                <Link to={`compute_resources/${row.id}/overview`}>
                    {row.name}
                </Link>
            ),
        },
        {
            key: 'colVmCount',
            title: <Translate content="computeResource.list.vmCount" />,
            render: (row: IComputeResourceResponse) => row.vms_count || '-',
        },
        {
            key: 'colStatus',
            title: <Translate content="computeResource.list.status" />,
            render: (row: IComputeResourceResponse) => <Status status={row.status} compact={true} />,
        },
        {
            key: 'colRecoverability',
            title: <Translate content="computeResource.resilienceStatus.list.recoverability" />,
            render: (row: IResilienceStatusTableComputeResource) => ( row.ready_for_recovery ? (
                <Icon name="check-mark-circle" intent="success" />
            ) : (
                <Icon name="remove" intent="danger" />
            )
            ),
        },
    ];

    return (
        <List
            emptyView={<EmptyView title="No data available" />}
            columns={columns}
            data={compute_resources}
            rowKey={(item) => String(item.id)}
        />
    );
};

export default ResilienceStatusTable;